import React from 'react';
import cx from 'classnames';
import { useTranslations } from '@unisporkal/localization';
import { RawHtml } from '@unisporkal/utilities';
import { useSiteMap } from '@unisporkal/sites';
import { useTheme } from '@unisporkal/themes';
import { ListItem } from '@unisporkal/alliance-ui';
import { useAsset } from '../../../../hooks/stateful/useAsset';
import CheckMarkIcon from '../../../../icons/CheckMark.svg?icon';
import InfoTooltip from '../../../InfoTooltip/InfoTooltip';
import styles from '../Messages.module.scss';

const BenefitsMessage = () => {
  const t = useTranslations();
  const { asset } = useAsset();
  const siteMap = useSiteMap();
  const theme = useTheme();
  const themeLink = theme.link || {};
  const isVideoTemplate = asset.isVideoTemplate();

  const renderTooltipContent = () => (
    <span
      className={styles.tooltipContent}
      data-testid="tooltip-content"
    >
      <div className={styles.tooltipTitle}>{t('gi_rf_includes')}</div>
      <ul className={styles.tooltipList}>
        <ListItem className={styles.tooltipListItem}>
          <CheckMarkIcon />
          {isVideoTemplate
            ? t('unlimited_video_plays_digital_impressions')
            : t('unlimited_print_runs')}
        </ListItem>
        <ListItem className={styles.tooltipListItem}>
          <CheckMarkIcon />
          {t('comprehensive_protection')}
        </ListItem>
        {!isVideoTemplate && (
          <ListItem className={cx(styles.tooltipListItem, themeLink.textLink)}>
            <CheckMarkIcon />
            <RawHtml>
              {t('straightfoward_discounts', {
                links: [
                  {
                    href: siteMap.cleanPath(`/${t('urls.plans_and_pricing')}`),
                    target: '_blank',
                    rel: 'noopener noreferrer',
                  },
                ],
              })}
            </RawHtml>
          </ListItem>
        )}
      </ul>
      <div className={cx(styles.tooltipBottomSection, themeLink.textLink)}>
        <RawHtml>
          {t('learn_more', {
            links: [
              {
                href: siteMap.licenseOverview(),
                target: '_blank',
                rel: 'noopener noreferrer',
              },
            ],
          })}
        </RawHtml>
      </div>
    </span>
  );

  return (
    <div
      className={styles.buyCardMessage}
      data-testid="benefits-message"
    >
      {isVideoTemplate
        ? t('rf_licenses_include_video_template')
        : t('rf_licenses_include')}
      <InfoTooltip content={renderTooltipContent()} />
    </div>
  );
};

export default BenefitsMessage;
